import { Box, IconButton, Typography, Grid, Skeleton, Avatar } from '@mui/material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PersonIcon from '@mui/icons-material/Person';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import MenuIcon from '@mui/icons-material/Menu';

function MobileFrame({ urlParams, ofrType, children, preview, prevLoader, handleButtonClick }) {
    const viewId = urlParams.get('view_id');
    const history = useHistory()
    const buttons = [
        { name: 'Rent Property', url: "list", ofr_type: "rent", icon: <HomeOutlinedIcon /> },
        { name: 'Buy Property', url: "list", ofr_type: "buy", icon: <HomeWorkOutlinedIcon /> },
        { name: 'Sell Your Property', url: "sell-your-property", icon: <AssignmentIndOutlinedIcon /> },
        { name: 'Be our Agent', url: "be-our-agent", icon: <PersonIcon /> },
        { name: 'Message Us', url: "message-us", icon: <EmailOutlinedIcon /> },
    ];

    const styles = {
        frame: {
            width: '100%',
            height: '100%',
            borderRadius: "22px",
            border: "9px solid",
            backgroundColor: '#fff',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
            position: 'relative',
            overflow: 'hidden',
        },
        notch: {
            width: "170px",
            height: "20.5px",
            borderRadius: '20px',
            backgroundColor: '#333',
            position: 'absolute',
            top: '10px',
            left: '50%',
            transform: 'translateX(-50%)',
        },
        screen: {
            width: '100%',
            //height: 'calc(100% - 56px - 48px)',
            height: "568px",
            borderRadius: '28px',
            backgroundColor: '#f9f9f9',
            position: 'relative',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        container: {
            flexGrow: 1,
        },
        footer: {
            // height: isSmallScreen ? '30px' : "48px",
            // borderTop: '1px solid #ddd',
            // position: 'sticky',
            // bottom: 16,
            // width: '100%',
            position: 'sticky',
            bottom: 0,
            width: '100%',
        },
    };

    const Back = ()=>{
        history.push(`/campaign/website?type=real-property&tab=list&offer_type=${urlParams.get('offer_type')}&property_type=${urlParams.get('property_type')}`)
    }
    return (
        <Box sx={styles.frame}>
            <Box width="100%" bgcolor="#fff" mt="45px" height="56px" display="flex">
                <Box sx={styles.notch}></Box>
                {   
                    !prevLoader.data ? (
                        <Box height="56px" width="100%" bgcolor={preview.data.top.bg_color} p={1.5} display="flex" alignItems="center">
                            { viewId === null ? 
                                ( 
                                    <Box width="100%" height="100%" display="flex">
                                        <Box width="100%" height="100%" display="flex" alignItems="center" gap={1}>
                                            <Box borderRadius={1} bgcolor="transparent" display="flex" justifyContent="center" alignItems="center" >
                                                <Avatar
                                                    variant="rounded"
                                                    src="https://marketing-system-repo.s3.amazonaws.com/mt/phases/1748398842578.webp"
                                                    alt="Centered Icon"
                                                />
                                            </Box>
                                            <Typography color="#fff" >
                                                {preview.data.top.title.value}
                                            </Typography>
                                        </Box>
                                        <Box display="flex" justifyContent="center" alignItems="center">
                                            <MenuIcon sx={{ color: "#fff" }}/>  
                                        </Box>
                                    </Box> 
                                ) 
                            : 
                                ( 
                                    <Box gap="8px" onClick={() => Back()} display="flex" alignItems="center" sx={{ width: 'fit-content', cursor: "pointer" }}>
                                        <KeyboardBackspaceIcon sx={{ color: '#FFFFFF' }} />
                                        <Typography fontSize="14px" color="#fff">Back</Typography>
                                    </Box> 
                                )
                            }
                        </Box>
                    ) : <Skeleton variant='text' width="100%" height="100%" sx={{ py: 4 }} /> 
                }
            </Box>
            <Box sx={styles.screen}>
                <Box flex={1} width="100%" overflow="hidden" sx={styles.container}>
                    {children}
                </Box>
                    { viewId === null && 
                        <Box sx={styles.footer}>
                            { !prevLoader.data ?
                                (
                                    <Box width="100%" bgcolor="#fff" display="flex" alignItems="center" p="0.1rem" sx={{ boxShadow:"rgba(0, 0, 0, 0.08) 0px -8px 16px 0px, rgba(0, 0, 0, 0.04) 0px 0px 4px 0px" }}>
                                        <Grid container justifyContent="space-between" >
                                            {buttons.map((button, k) => (
                                                <Grid item key={k} xs={2.3}
                                                    sx={{
                                                        cursor: "pointer", borderRadius: "8px", 
                                                        bgcolor: (urlParams.get('tab') === "list" ? ofrType === button.ofr_type : urlParams.get('tab') === button.url) ? `${preview.data.top.bg_color}4D` : "transparent"
                                                    }}
                                                    borderRadius={1}
                                                    onClick={() => handleButtonClick(button.url, button.ofr_type)} // Fixed
                                                >
                                                    <Box textAlign="center">
                                                        <IconButton
                                                            size="small"
                                                            disableRipple
                                                            sx={{
                                                                pt: "8px",
                                                                fontSize: '16px', 
                                                                width: '20px',
                                                                height: '20px',
                                                                color: (urlParams.get('tab') === "list" ? ofrType === button.ofr_type : urlParams.get('tab') === button.url) ? `${preview.data.top.bg_color}` : "#808080"
                                                            }}
                                                        >
                                                            {button.icon}
                                                        </IconButton>
                                                        <Typography px={0.5} pt={1}
                                                            noWrap
                                                            fontSize={8}
                                                            color={(urlParams.get('tab') === "list" ? ofrType === button.ofr_type : urlParams.get('tab') === button.url) ? `${preview.data.top.bg_color}` : "#808080"}
                                                        >
                                                            {button.name}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Box>
                                ) : <Skeleton variant='text' sx={styles.skeletonFooter} />
                            }
                        </Box>  
                    }
            </Box>
        </Box>
    );
}

export default MobileFrame;